import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function LostDialog({ open, onOpenChange, reasons, reference, onSubmit }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const needsNote = reason === "OTHER" && !note.trim();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="wf-lost-dialog">
        <DialogHeader>
          <DialogTitle>Mark {reference} as lost</DialogTitle>
          <DialogDescription>A managed reason is required. Marking an enquiry lost closes the enquiry only; it never cancels a booking.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Reason</Label>
            <Select value={reason} onValueChange={setReason}>
              <SelectTrigger data-testid="wf-lost-reason"><SelectValue placeholder="Choose a reason" /></SelectTrigger>
              <SelectContent>{reasons.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Note {reason === "OTHER" ? "(required)" : "(optional)"}</Label>
            <Textarea data-testid="wf-lost-note" value={note} onChange={(e) => setNote(e.target.value)} rows={3} placeholder="Short explanation for colleagues" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="wf-lost-cancel">Cancel</Button>
          <Button disabled={!reason || needsNote} onClick={() => onSubmit(reason, note.trim() || null)} data-testid="wf-lost-submit">Mark as lost</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
